













































import { Component, Vue, Watch } from 'vue-property-decorator';

@Component({
  name: 'Export',
  components: {},
})
export default class extends Vue {
  private isLoading = false;

  private listProduct: any[] = [];

  private selectedProduct: any = null;

  private amount = 0;

  private listAccessories: any[] = [];

  protected async created() {
    await this.fetchProduct();
  }

  @Watch('selectedProduct')
  protected async onProductChange(value: any) {
    this.listAccessories = (await this.$api.products.getProduct(value)).lksp;
  }

  private async fetchProduct() {
    this.isLoading = true;
    this.listProduct = await this.$api.products.getListProduct();
    this.isLoading = false;
  }

  private formatAmount(row: any, column: any, value: any) {
    return this.amount * Number(value);
  }
}
